export default __webpack_public_path__ + "static/media/image11.2aadc4a5.jpg";